export default __webpack_public_path__ + "media/images/mailer-new/heading/user-8a7c86b15a87b082d6ccd0da1fe92d3c.png";